import { createAction, props } from "@ngrx/store";

export const showHideCatalogo = createAction(
  "[Catalogos usuarios] Ocultar o mostrar edición y nuevo registro users",
  props<{
    tipoCatalogo: string;
    mostrarEditar: boolean;
    mostrarNuevo: boolean;
    guardando: boolean;
  }>()
);

export const resetHideCatalogo = createAction(
  "[Catalogos usuarios] reset edición y nuevo registro"
);
